// 공용 플랫폼(로그인·결제) 주소와 이 MVP 의 이름 — 코어가 소유하고 auth·pay 플러그인이 기본값으로 쓴다 (prd/112 FR-008)
// 플랫폼은 공인 호스트 HTTPS 로만 부른다. 플랫폼 코드 import·패키지 의존은 경계 검사가 막는다 (new-new-thing/CLAUDE.md 절대 규칙 2)

/** 이 MVP 의 이름 — 플랫폼 등록 이름(tenant)과 같다. new_mvp.py 가 채운다. 손으로 바꾸지 않는다 */
export const MVP_NAME = 'serial';

const PUBLIC_PLATFORM_URL = 'https://platform-api.nnt.whif.io';

/** 로컬 개발용 가짜 플랫폼 주소 — `dev-local.sh` 가 이 포트에 띄운다 (api/cmd/devplatform). 로그인·결제·모델 응답이 전부 가짜다 */
export const LOCAL_PLATFORM_URL = 'http://localhost:8091';

/** 가짜 플랫폼을 보는 vite 모드 이름. `local` 은 vite 가 모드 이름으로 받지 않는다(.env.local 과 겹친다) */
export const LOCAL_MODE = 'fake-platform';

/**
 * 가짜 플랫폼을 보는 조건은 셋이 다 맞을 때다 (`pnpm dev:local`): 개발 서버 · `fake-platform` 모드 · 화면이 내 컴퓨터(localhost)에서 열림.
 * 보통의 빌드는 개발 서버가 아니라서 공인 주소다. 누가 개발 모드로 빌드해(`NODE_ENV=development vite build --mode fake-platform`) 배포하더라도
 * 화면이 localhost 가 아니므로 공인 주소다. 주소를 환경변수로 받지 않는다
 */
export function platformUrlFor(dev: boolean, mode: string | undefined, hostname: string | undefined): string {
  const local = hostname === 'localhost' || hostname === '127.0.0.1';
  return dev && mode === LOCAL_MODE && local ? LOCAL_PLATFORM_URL : PUBLIC_PLATFORM_URL;
}

export const PLATFORM_URL = platformUrlFor(import.meta.env?.DEV === true, import.meta.env?.MODE, globalThis.location?.hostname);
